import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormClasificadorEstadistico from './FormClasificadorEstadistico';

import getClasificadorEstadisticos from '../../../../graphql/querys/clasificadores/getClasificadoresEstadisticos.graphql';
import insertClasificadorEstadistico from '../../../../graphql/mutations/clasificadores/insertClasificadorEstadistico.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(insertClasificadorEstadistico, {
  name: 'insertClasificadorEstadistico',
  options: {
    refetchQueries: [{ query: getClasificadorEstadisticos }],
  },
})
class CrearClasificadorEstadistico extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clasificadorEstadistico: {
        nombre: '',
        descripcion: '',
      },
      step: 0,
      loading: false,
    };

    this.guardarClasificadorEstadistico = this.guardarClasificadorEstadistico.bind(
      this
    );
    this.onCancel = this.onCancel.bind(this);
  }

  guardarClasificadorEstadistico(clasificadorEstadistico) {
    this.props
      .insertClasificadorEstadistico({
        variables: {
          clasificadorEstadistico,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Creacion Correcta',
          description:
            'Se ha registrado la nueva clasificador estadistico exitosamente',
        });

        this.props.history.push('/admin/otros/clasificadoresEstadisticos');
      })
      .catch(err => {
        console.log('Error en la creacion de la clasificador estadistico');
        console.log(err);
        errorService(err, {
          clasificadorEstadistico,
        });

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Clasificador Estadistico</Breadcrumb.Item>
          <Breadcrumb.Item>Crear</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Clasificador Estadistico
          </h2>
          <br />
          <div style={estiloContent}>
            <FormClasificadorEstadistico
              className="formularios"
              onSubmit={this.guardarClasificadorEstadistico}
              onAnterior={() =>
                this.props.history.push(
                  '/admin/otros/clasificadoresEstadisticos'
                )
              }
              datos={this.state.clasificadorEstadistico}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearClasificadorEstadistico);
